import React from "react";
import { Link } from "react-router-dom";
import {
  FaTachometerAlt,
  FaRegNewspaper,
  FaPenNib,
  FaUsers,
  FaTags,
  FaImages,
  FaCog,
  FaArrowLeft,
} from "react-icons/fa";

import { logoutAdmin } from "../../services/authApi";
import "./adminDashboard.css";

const items = [
  { key: "dashboard", label: "Dashboard", href: "/admin", icon: <FaTachometerAlt /> },
  { key: "posts", label: "Posts", href: "/admin/posts", icon: <FaRegNewspaper /> },
  { key: "createPost", label: "Create Post", href: "/admin/articles/new", icon: <FaPenNib /> },
  { key: "messages", label: "Messages", href: "/admin/messages", icon: <FaUsers /> },
  { key: "volunteers", label: "Volunteers", href: "/admin/volunteers", icon: <FaTags /> },
  { key: "media", label: "Media Library", href: "/admin/media", icon: <FaImages /> },
  { key: "settings", label: "Settings", href: "/admin/settings", icon: <FaCog /> },
];

export default function AdminSidebar({ activeKey = "dashboard", onNavigate }) {
  return (
    <div className="adminSideInner">
      <div className="adminSideBrand">
        <div className="adminSideBrandTitle">Admin</div>
        <div className="adminSideBrandSub">Content Management</div>
      </div>

      <nav className="adminSideNav" aria-label="Admin navigation">
        {items.map((it) => {
          const active = it.key === activeKey;
          return (
            <Link
              key={it.key}
              to={it.href}
              className={`adminSideLink ${active ? "active" : ""}`}
              onClick={() => onNavigate?.(it)}
            >
              <span className="adminSideIcon" aria-hidden="true">
                {it.icon}
              </span>
              <span>{it.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="adminSideFooter">
        <a
          href="/admin/login"
          className="adminBackLink"
          onClick={async (e) => {
            e.preventDefault();
            try {
              await logoutAdmin();
            } catch {
              // ignore
            }
            window.location.href = "/admin/login";
          }}
        >
          <span className="adminBackIcon" aria-hidden="true">
            <FaArrowLeft />
          </span>
          Logout
        </a>
      </div>
    </div>
  );
}

